var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentsNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072b2;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_137",
    "data-name": "Layer 137"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300.91,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.86,245.63h-90v-84.9A56,56,0,0,0,301,104.88h0a56,56,0,0,0-55.85,55.85v84.9H165.25a56,56,0,0,0-55.85,55.85h0a56,56,0,0,0,55.85,55.85h79.92v85A56,56,0,0,0,301,498.19h0a56,56,0,0,0,55.85-55.86v-85h90a56,56,0,0,0,55.85-55.85h0A56,56,0,0,0,446.86,245.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsNewEntry);
export default __webpack_public_path__ + "static/media/appointments_new_entry.47c67e862b8bcc4b5708556830d92d5e.svg";
export { ForwardRef as ReactComponent };